import React from 'react'
import { AuditOutlined, MedicineBoxOutlined } from '@ant-design/icons'
import { Badge, Tooltip } from 'antd'
import type { EmployeeListItem } from '../interfaces'

const ALERT_COLORS = {
  warning: '#fa8c16',
  expired: '#f5222d',
} as const

const ALERT_TITLES = {
  warning: 'Срок истекает в ближайшие 30 дней',
  expired: 'Срок истёк',
} as const

type VisibleAlert = 'warning' | 'expired'

function isVisibleAlert(alert: EmployeeListItem['patent_alert']): alert is VisibleAlert {
  return alert === 'warning' || alert === 'expired'
}

function ComplianceIconChip({
  alert,
  Icon,
  label,
}: {
  alert: EmployeeListItem['patent_alert']
  Icon: typeof AuditOutlined
  label: string
}) {
  if (!isVisibleAlert(alert)) return null

  const color = ALERT_COLORS[alert]

  return (
    <Tooltip title={`${label}: ${ALERT_TITLES[alert]}`}>
      <Badge
        count={<Icon style={{ color, fontSize: 16 }} />}
        color={color}
        title={ALERT_TITLES[alert]}
      />
    </Tooltip>
  )
}

export function hasComplianceListAlerts(record: EmployeeListItem): boolean {
  if (record.status === 'dismissed') return false
  return isVisibleAlert(record.patent_alert) || isVisibleAlert(record.medical_alert)
}

export function ComplianceListIcons({ record }: { record: EmployeeListItem }) {
  if (!hasComplianceListAlerts(record)) return null

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 3,
        flexShrink: 0,
      }}
    >
      <ComplianceIconChip alert={record.patent_alert} Icon={AuditOutlined} label="Патент" />
      <ComplianceIconChip
        alert={record.medical_alert}
        Icon={MedicineBoxOutlined}
        label="Мед. полис"
      />
    </span>
  )
}
